import { mainApi} from "../../app/services/mainApiSlice";
import { IUserByIdResponse, IUserResponse } from "../../types/user";
const commonUrl: string = "/admin/user";

const userApi = mainApi.injectEndpoints({
  endpoints: (builder) => ({

    // Get All rider
    // Fetches the real total first (size=1), then loads exactly that many rows.
    getAllRider: builder.query<IUserResponse, void>({
      async queryFn(_arg, _api, _extraOptions, fetchWithBQ) {
        const countResult = await fetchWithBQ(`${commonUrl}/get-all-rider?page=0&size=1`);
        if (countResult.error) return { error: countResult.error };

        const total = (countResult.data as IUserResponse).data.totalElements ?? 0;
        if (total <= 1) return { data: countResult.data as IUserResponse };

        const allResult = await fetchWithBQ(`${commonUrl}/get-all-rider?page=0&size=${total}`);
        if (allResult.error) return { error: allResult.error };
        return { data: allResult.data as IUserResponse };
      },
      providesTags: [{ type: "Main", id: "USER" }],
    }),

    getRiderById: builder.query<IUserByIdResponse, string | undefined>({
      query: (id) => ({
        url: `${commonUrl}/rider/${id}`,
        method: "GET",
        
      }),
      providesTags: [{ type: "Main", id: "USER" }],
    }),
 
    deleteRiderById: builder.mutation<void, number | undefined>({
      query: (id) => ({
        url: `${commonUrl}/delete-rider/${id}`,
        method: "DELETE",
        
      }),
      invalidatesTags: [{ type: "Main", id: "USER" }],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetAllRiderQuery,
  useGetRiderByIdQuery,
  useDeleteRiderByIdMutation,
} = userApi;